import React, {useEffect, useRef, useState} from 'react'
import Container from "@mui/material/Container";
import axios from "axios";
import {AED_PRICE, PRODUCTS_URL} from "../config";
import {makeStyles} from "@mui/styles";
import {useParams} from "react-router-dom";
// import {HorizontalGridLines, LineMarkSeries, VerticalGridLines, XAxis, XYPlot, YAxis} from 'react-vis';
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Link from "@mui/material/Link";
import {
    Area,
    AreaChart,
    Brush,
    CartesianGrid,
    Legend,
    Line,
    LineChart,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    YAxis
} from "recharts";

export default function ProductPage() {


    const [priceData, setPriceData] = useState([]);
    const [costData, setCostData] = useState([]);
    const [allData, setAllData] = useState([]);
    const [product, setProduct] = useState({});
    const [aedPrice, setAedPrice] = useState(0);
    const costRef = useRef();
    const {id} = useParams();
    const currencyFormatter = new Intl.NumberFormat('fa-IR', {
        style: 'currency',
        currency: 'IRR',
        currencyDisplay: 'code',
        maximumFractionDigits: 0
    });

    async function fetchAEDData() {
        const {data} = await axios.get(AED_PRICE);

        const {value} = data;
        setAedPrice(value)
    }

    async function fetchProductData() {
        const {data} = await axios.get(`${PRODUCTS_URL}/${id}`);
        setProduct(data)
    }


    async function fetchChartData() {
        const [{data: priceRecords}, {data: costRecords}] = await Promise.all([
            axios.get(`${PRODUCTS_URL}/${id}/price`),
            axios.get(`${PRODUCTS_URL}/${id}/cost`)]);
        setPriceData(priceRecords.map(({date, value}) => ({date: new Date(date), price: value})));
        setCostData(costRecords.map(({date, value}) => ({date: new Date(date), cost: value})))
    }


    useEffect(() => {
        fetchAEDData().then(() => fetchProductData()).then(() => fetchChartData())
    }, []);


    useEffect(() => {
        console.log(allData)
    }, [allData]);


    useEffect(() => {
        const integratedDate = formatData(priceData, costData);
        setAllData(integratedDate)
    }, [costData]);

    async function handleSubmit(e) {
        e.preventDefault();
        if (!costRef.current.value)
            return

        const cost = Number.parseInt(costRef.current.value);
        const aed = Number.parseInt(aedPrice.replace(',', ''));

        try {
            await axios.post(`${PRODUCTS_URL}/${id}/cost`,
                {value: cost * aed},
                {headers: {'Content-Type': 'application/json'}});
            window.location.reload()
        } catch {

        }
    }

    const classes = useStyles();


    return (
        <>
            <Container className={classes.header}>
                <Grid container justifyContent='space-between'>
                    <Grid item xs={3}>
                        قیمت درهم: {aedPrice} ریال
                    </Grid>
                    <Grid item xs={8} md={4}>
                        <form onSubmit={handleSubmit}>
                            <Grid container>
                                <Grid item xs={3}>
                                    <Button size='large' type='submit' variant='outlined'>ثبت</Button>
                                </Grid>
                                <Grid item xs={9}>
                                    <TextField label="قیمت تمام‌شده روز" size="small" inputRef={costRef}/>
                                </Grid>
                            </Grid>
                        </form>

                    </Grid>
                </Grid>
            </Container>
            <Container maxWidth='lg'>
                <Link href={product.dgLink} variant='h6' target='_blank'
                      underline='hover' rel="noreferrer" color='text.primary'>
                    {product.fullName}
                </Link>

                <div className={classes.plot}>
                    <ResponsiveContainer width="90%" height={350}>

                        <LineChart margin={{left: -10, right: 10}} className={classes.plot}
                                   data={formatData(priceData, costData)} syncId="0">
                            <Legend verticalAlign="top" height={36}/>
                            <CartesianGrid strokeDasharray="4"/>
                            <XAxis height={40} tick={{fontSize: 10, strokeWidth: 2}} dataKey='date'
                                   format={formatDate} tickFormatter={formatDate} scale='time'/>
                            <YAxis width={40} yAxisId="left" tick={{fontSize: 10, strokeWidth: 2}}
                                   domain={[min => min * .95, max => max * 1.05]}
                                   tickFormatter={currencyFormatter.format} scale='linear'/>
                            <Tooltip formatter={currencyFormatter.format} labelFormatter={formatDate}/>
                            <Line yAxisId="left" type="monotone" dataKey="price" stroke="teal"
                                  strokeWidth={2} name='قیمت فروش'/>
                            <Line yAxisId="left" type="monotone" dataKey="cost" stroke="orange"
                                  strokeWidth={2} name='قیمت تمام‌شده'/>
                        </LineChart>
                    </ResponsiveContainer>

                    <ResponsiveContainer width="90%" height={350}>

                        <AreaChart margin={{left: -10, right: 10}} className={classes.plot}
                                   data={formatData(priceData, costData)} syncId="0">
                            <Legend verticalAlign="top" height={36}/>
                            <CartesianGrid strokeDasharray="4"/>
                            <XAxis height={40} tick={{fontSize: 10, strokeWidth: 2}} dataKey='date'
                                   format={formatDate}  tickFormatter={formatDate} scale='time'/>
                            <YAxis width={40} yAxisId="left" tick={{fontSize: 10, strokeWidth: 2}}
                                   tickFormatter={x => currencyFormatter.format(x)}/>
                            <Tooltip formatter={currencyFormatter.format} labelFormatter={formatDate}/>
                            <Area yAxisId="left" type="monotone" dataKey="margin" stroke="slategray" fill="slategray"
                                  strokeWidth={2} name='سود فروش' dot/>
                            <Brush tickFormatter={formatDate}/>

                        </AreaChart>
                    </ResponsiveContainer>
                </div>


            </Container>
        </>
    )
}


const useStyles = makeStyles(theme => ({
    header: {
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        padding: theme.spacing(2),
        marginBottom: theme.spacing(1),
        backgroundColor: 'white',
        borderBottom: '2px solid black'
    },
    plot: {
        margin: '0 auto',
        padding: theme.spacing(1),
        marginTop: theme.spacing(2)
    }
}))

function formatDate(date) {
    return new Date(date).toLocaleString('fa-IR');
}

function formatData(priceData, costData) {
    if (costData.length === 0)
        return priceData

    let array = ([...priceData, ...costData]).sort((a, b) => a.date - b.date)

    if (array.length === 0)
        return array;
    if (!array[0].cost)
        array[0].cost = array[0].price;
    if (!array[0].price)
        array[0].price = array[0].cost;

    array[0].margin = array[0].price - array[0].cost

    for (let i = 1; i < array.length; i++) {
        if (!array[i].cost)
            array[i].cost = array[i - 1].cost
        if (!array[i].price)
            array[i].price = array[i - 1].price
        array[i].margin = array[i].price - array[i].cost
    }

    return array.map(data => ({...data, date: data.date}))
}
